// ---------------------------------------------------------------------------
// Tokens
// ---------------------------------------------------------------------------
export const mockTokens = [
    {
        id: 1,
        name: 'Math Genius',
        earningCriteria: 'Score 95% or above on all unit tests',
        tokenImageUrl: 'https://cdn.example.com/math-genius.png',
        tokenImageKey: 'math-genius-v1',
        assignedCount: 10,
        isSchoolShared: false,
        createdAt: '2026-01-10T08:00:00Z',
    },
    {
        id: 2,
        name: 'Science Star',
        earningCriteria: 'Complete all science lab assignments',
        tokenImageUrl: 'https://cdn.example.com/science-star.png',
        tokenImageKey: 'science-star-v1',
        assignedCount: 5,
        isSchoolShared: true,
        createdAt: '2026-02-14T10:30:00Z',
    },
    {
        id: 3,
        name: 'Reading Champion',
        earningCriteria: 'Read 10 books this semester',
        tokenImageUrl: 'https://cdn.example.com/reading-champion.png',
        tokenImageKey: 'reading-champion-v1',
        assignedCount: 0,
        isSchoolShared: false,
        createdAt: '2026-03-01T09:00:00Z',
    },
];
export const mockGetTokensResponse = {
    tokens: mockTokens,
};
// ---------------------------------------------------------------------------
// Token details
// ---------------------------------------------------------------------------
export const mockTokenDetails = [
    {
        ...mockTokens[0],
        description: 'Awarded to students who excel in mathematics.',
        skillTags: [
            {
                id: 101,
                idOntology: 'onto-001',
                name: 'Mathematics',
                alternateName: null,
            },
            {
                id: 102,
                idOntology: null,
                name: 'Problem Solving',
                alternateName: null,
            },
        ],
    },
    {
        ...mockTokens[1],
        description: 'Awarded to students who demonstrate a love of science.',
        skillTags: [
            { id: 103, idOntology: 'onto-002', name: 'Science', alternateName: null },
        ],
    },
    {
        ...mockTokens[2],
        description: '',
        skillTags: [],
    },
];
/** Returns details for a given token id, mirroring the real endpoint behaviour. */
export const getMockTokenDetails = (id) => mockTokenDetails.find((t) => t.id === id);
// ---------------------------------------------------------------------------
// Ontology skill tags
// ---------------------------------------------------------------------------
/**
 * Wire-format mock data for the /api/ontology-skills/search endpoint.
 * The real endpoint returns Array<{ id: string; name: string }>; the RTK Query
 * transformResponse maps each entry to an ICustomSkillTag (id=0, idOntology=id).
 */
export const mockOntologySkillTags = [
    { id: 'onto-math-001', name: 'Number Sense' },
    { id: 'onto-math-002', name: 'Algebra' },
    { id: 'onto-math-003', name: 'Geometry' },
    { id: 'onto-math-004', name: 'Fractions and Decimals' },
    { id: 'onto-math-005', name: 'Data Analysis' },
    { id: 'onto-math-006', name: 'Probability' },
    { id: 'onto-sci-001', name: 'Scientific Method' },
    { id: 'onto-sci-002', name: 'Life Science' },
    { id: 'onto-sci-003', name: 'Earth Science' },
    { id: 'onto-ela-001', name: 'Reading Comprehension' },
    { id: 'onto-ela-002', name: 'Writing Skills' },
    { id: 'onto-gen-001', name: 'Critical Thinking' },
    { id: 'onto-gen-002', name: 'Problem Solving' },
];
// ---------------------------------------------------------------------------
// Token image URLs
// ---------------------------------------------------------------------------
const getMockTokenIconUrl = (iconNumber) => `data:image/svg+xml,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62">
      <rect width="62" height="62" rx="12" fill="#E6F4FF" />
      <circle cx="31" cy="31" r="16" fill="#147CD1" />
      <text x="31" y="37" fill="#FFFFFF" font-family="Arial, sans-serif" font-size="16" font-weight="700" text-anchor="middle">${iconNumber}</text>
    </svg>
  `)}`;
export const mockGetTokenImageUrlsResponse = {
    images: [
        {
            tokenImageKey: 'math-genius-v1',
            tokenImageUrl: 'https://cdn.example.com/math-genius.png',
        },
        {
            tokenImageKey: 'science-star-v1',
            tokenImageUrl: 'https://cdn.example.com/science-star.png',
        },
        {
            tokenImageKey: 'reading-champion-v1',
            tokenImageUrl: 'https://cdn.example.com/reading-champion.png',
        },
        ...Array.from({ length: 17 }, (_, index) => {
            const iconNumber = index + 4;
            return {
                tokenImageKey: `token-icon-${iconNumber}-v1`,
                tokenImageUrl: getMockTokenIconUrl(iconNumber),
            };
        }),
    ],
};
// ---------------------------------------------------------------------------
// Assign token response
// ---------------------------------------------------------------------------
export const mockAssignTokenResponse = {
    assignmentIds: [2001, 2002],
    assignedStudentIds: [
        4784890, 4784888, 228507, 1239828, 3075501, 5444, 1561547,
    ],
    skippedStudentIds: [167915, 4419438],
};
// ---------------------------------------------------------------------------
// Create and assign token response
// ---------------------------------------------------------------------------
export const mockCreateAndAssignTokenResponse = {
    createdTokenId: 1050,
    assignmentIds: [2001, 2002],
    assignedStudentIds: [
        4784890, 4784888, 228507, 1239828, 3075501, 5444, 1561547,
    ],
    skippedStudentIds: [167915, 4419438],
};
// ---------------------------------------------------------------------------
// Teacher students
// ---------------------------------------------------------------------------
export const mockTeacherStudentsResponse = {
    students: [
        {
            id: 5444,
            firstName: 'Charlie',
            lastName: 'Brown',
            sections: [
                {
                    id: 2163188,
                    name: '[SHP] [Test] 24/25 CRP: Medical Terminology (2026)',
                },
            ],
        },
        {
            id: 112801,
            firstName: 'Scott',
            lastName: 'Capone',
            sections: [{ id: 2163211, name: 'SectionVista6_24' }],
        },
        {
            id: 112802,
            firstName: 'Karen',
            lastName: 'Capone',
            sections: [
                { id: 2160526, name: '[SHP] 24/25 CRP: Medical Terminology 1' },
                { id: 2160531, name: '[SHP] 25/26 CRP: Health Science Foundations 1' },
                { id: 2161228, name: '[SHP] Biology 26' },
                { id: 2163211, name: 'SectionVista6_24' },
            ],
        },
        {
            id: 112810,
            firstName: 'Sandy',
            lastName: 'Capone',
            sections: [{ id: 2163211, name: 'SectionVista6_24' }],
        },
        {
            id: 112813,
            firstName: 'Heather',
            lastName: 'Capone',
            sections: [
                { id: 2160526, name: '[SHP] 24/25 CRP: Medical Terminology 1' },
                { id: 2160531, name: '[SHP] 25/26 CRP: Health Science Foundations 1' },
                { id: 2163211, name: 'SectionVista6_24' },
            ],
        },
        {
            id: 167915,
            firstName: 'Meaghan',
            lastName: 'Demo',
            sections: [
                { id: 49212, name: 'Jen Teacher Homeroom' },
                { id: 1887463, name: 'Algebra 1 A' },
                { id: 1887858, name: 'English 12 B' },
                { id: 1973928, name: 'English 10 A' },
                { id: 1974541, name: 'World History B' },
                { id: 1974813, name: 'English 10 B' },
                { id: 1974820, name: 'Algebra 1 B' },
                { id: 1974883, name: 'Biology B' },
                { id: 2111221, name: "Jen Teacher's Homeroom" },
                { id: 2163120, name: 'Primary Teacher for OneRoster - 6/22' },
                { id: 2163216, name: 'CMW-RT-S12-T1-1' },
            ],
        },
        {
            id: 224367,
            firstName: 'Marcie',
            lastName: 'Demo',
            sections: [
                { id: 226203, name: 'Successmaker Test Section' },
                { id: 1887463, name: 'Algebra 1 A' },
                { id: 1973928, name: 'English 10 A' },
                { id: 1974541, name: 'World History B' },
                { id: 1974813, name: 'English 10 B' },
                { id: 2111221, name: "Jen Teacher's Homeroom" },
                { id: 2153601, name: 'Biology B' },
            ],
        },
        {
            id: 228507,
            firstName: 'Claire',
            lastName: 'Training',
            sections: [{ id: 1551234, name: 'Algebra Readiness (Pre-Algebra) A' }],
        },
        {
            id: 265992,
            firstName: 'Amanda',
            lastName: 'Demo',
            sections: [
                { id: 102328, name: 'Educational Technology and Online Learning 8' },
                { id: 1887463, name: 'Algebra 1 A' },
                { id: 1973928, name: 'English 10 A' },
                { id: 1974813, name: 'English 10 B' },
                { id: 1974883, name: 'Biology B' },
                { id: 2163211, name: 'SectionVista6_24' },
            ],
        },
        {
            id: 375460,
            firstName: 'Tyler',
            lastName: 'Demo',
            sections: [
                { id: 1887462, name: 'World History I A' },
                { id: 1887463, name: 'Algebra 1 A' },
                { id: 1973928, name: 'English 10 A' },
                { id: 1974813, name: 'English 10 B' },
                { id: 1974820, name: 'Algebra 1 B' },
                { id: 2163211, name: 'SectionVista6_24' },
            ],
        },
        {
            id: 495693,
            firstName: 'Muffy',
            lastName: 'Demo',
            sections: [
                { id: 1819805, name: 'Test Section' },
                { id: 1887463, name: 'Algebra 1 A' },
                { id: 1974541, name: 'World History B' },
                { id: 1974883, name: 'Biology B' },
                { id: 2111221, name: "Jen Teacher's Homeroom" },
            ],
        },
        {
            id: 960103,
            firstName: 'Isela',
            lastName: 'Demo',
            sections: [
                { id: 263408, name: 'Science K A' },
                { id: 1887463, name: 'Algebra 1 A' },
                { id: 2111221, name: "Jen Teacher's Homeroom" },
                { id: 2153584, name: 'Language Arts 7 B' },
            ],
        },
        {
            id: 1179069,
            firstName: 'ReviewerTWO',
            lastName: 'Connections',
            sections: [
                { id: 1887463, name: 'Algebra 1 A' },
                { id: 1974883, name: 'Biology B' },
            ],
        },
        {
            id: 1561547,
            firstName: 'Gavin',
            lastName: 'Demo',
            sections: [
                { id: 988485, name: 'Reading Wonders Test (IA 2019394)' },
                { id: 1887463, name: 'Algebra 1 A' },
                { id: 1973601, name: 'Math 7 B' },
                { id: 1974541, name: 'World History B' },
                { id: 2111221, name: "Jen Teacher's Homeroom" },
                { id: 2163211, name: 'SectionVista6_24' },
            ],
        },
        {
            id: 1935850,
            firstName: 'Gus',
            lastName: 'Demo',
            sections: [
                { id: 1972527, name: 'Science 2 A' },
                { id: 2111221, name: "Jen Teacher's Homeroom" },
                { id: 2163211, name: 'SectionVista6_24' },
            ],
        },
        {
            id: 2280210,
            firstName: 'Barbara',
            lastName: 'Demo',
            sections: [
                { id: 28055, name: 'Algebra 2 A' },
                { id: 1552122, name: 'Algebra 1 A' },
                { id: 2111221, name: "Jen Teacher's Homeroom" },
                { id: 2163211, name: 'SectionVista6_24' },
                { id: 2163216, name: 'CMW-RT-S12-T1-1' },
            ],
        },
        {
            id: 3075501,
            firstName: 'Parker',
            lastName: 'Training',
            sections: [
                { id: 1887314, name: 'Educational Technology and Online Learning 1' },
            ],
        },
        {
            id: 3543545,
            firstName: 'Lou',
            lastName: 'Demo',
            sections: [
                { id: 2094420, name: 'Math K B' },
                { id: 2111221, name: "Jen Teacher's Homeroom" },
                { id: 2163216, name: 'CMW-RT-S12-T1-1' },
            ],
        },
        {
            id: 4784890,
            firstName: 'Clara',
            lastName: 'Demo',
            sections: [
                { id: 1887958, name: 'Art History B: LCS' },
                { id: 2163211, name: 'SectionVista6_24' },
            ],
        },
        {
            id: 5832461,
            firstName: 'Validation',
            lastName: 'Testing',
            sections: [
                { id: 1973928, name: 'English 10 A' },
                { id: 2048174, name: 'AI test section Biology A 164969 C$' },
            ],
        },
        {
            id: 5832463,
            firstName: 'Currick',
            lastName: 'Testing',
            sections: [
                { id: 1164569, name: 'Art 3' },
                { id: 1973928, name: 'English 10 A' },
                { id: 2048174, name: 'AI test section Biology A 164969 C$' },
            ],
        },
        {
            id: 6165476,
            firstName: 'Adley',
            lastName: 'Curriculum',
            sections: [{ id: 2163211, name: 'SectionVista6_24' }],
        },
    ],
};
